import './list-item.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
class ListItem extends Component {
  static propTypes = {
    name: PropTypes.string,
    imgurl: PropTypes.string,
    appid: PropTypes.string,
    appurl: PropTypes.string,
  };

  sendStatClick = () => {
    const { appid } = this.props;
    sendStat(
      'RP_STORE',
      '作品案例详情页',
      '点击作品相关推荐作品',
      Stat.ACTION_CLICK,
      {
        id: 'web_apppreview_detail_tuijian_click',
        app_id: appid,
      }
    );
  };

  render() {
    const { name, imgurl, appurl } = this.props;
    const index = appurl.lastIndexOf('/');
    const shortUrl = appurl.substring(index + 1);
    const url = `/preview/app-${shortUrl}.html`;
    return (
      <li className="list-item">
        <a
          href={url}
          onClick={this.sendStatClick.bind(this)}
          target="_blank"
          rel="noopener noreferrer">
          <div className="item-cover">
            <img className="item-image" src={imgurl} alt={name} />
          </div>
          <h2 className="item-title">{name}</h2>
        </a>
      </li>
    );
  }
}

export default ListItem;
